import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useSuiteHeaderTheme } from '@ms/yammer-hooks/dist/suiteHeaderTheme';
import {
  ITheme,
  createCustomizedThemeWithSlotOverrides,
  updatedDarkTheme,
} from '@ms/yammer-web-core-ui/dist/util/theme';
import { useMemo } from 'react';

const getName = (id?: string, type?: string) => {
  const nameParts = ['yammerWeb'];
  if (id) {
    nameParts.push(`id:${id}`);
  }
  if (type) {
    nameParts.push(`type:${type}`);
  }

  return nameParts.join('-');
};

type UseThemeWithSuiteHeaderOverrides = () => ITheme;
export const useThemeWithSuiteHeaderOverrides: UseThemeWithSuiteHeaderOverrides = () => {
  const { colors, isInverted, id, type } = useSuiteHeaderTheme();

  const shouldUseUpdatedDarkTheme = useExperimentTreatmentWithoutReporting(Experiment.UpdatedDarkTheme) === 'enabled';

  return useMemo(
    () =>
      isInverted && shouldUseUpdatedDarkTheme
        ? updatedDarkTheme
        : createCustomizedThemeWithSlotOverrides({
            name: getName(id, type),
            theme: { isInverted },
            paletteOverrides: colors,
          }),
    [colors, isInverted, id, shouldUseUpdatedDarkTheme, type]
  );
};
